export const classDetailsSx = {
  containerBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    width: '100%',
    alignItems: 'center',
    py: 3,
    gap: 4,
    borderBottom: '2px solid lightgray'
  },
  infoBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    width: { sm: '60%' }
  },
  startDateText: {
    fontWeight: '500',
    fontSize: '16px'
  },
  startDateValue: {
    fontWeight: '800'
  },
  dayText: {
    fontWeight: '900',
    fontSize: '15px'
  },
  timeText: {
    fontWeight: '600',
    fontSize: '15px'
  },
  noScheduleText: {
    fontWeight: '500',
    fontSize: '15px',
    color: 'gray'
  },
  durationText: {
    fontWeight: '900',
    pt: 1,
    fontSize: '15px'
  },
  durationValue: {
    fontWeight: '600',
    fontSize: '15px'
  },
  actionBox: {
    width: { sm: '40%' }
  },
  classFullText: {
    fontSize: "22px",
    fontWeight: "bold",
    pl: 1
  }
};
